<template>
      <!-- <header class="header">
      <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover">

      <div class="logo">
        <img src="/assets/svgs/logo.svg" alt="Logo" />
      </div>
      <button class="menu-icon">
        <img src="/assets/svgs/burger.svg" alt="Menu" />
      </button>
    </header> -->
    <nav-bar />
  <div>
    <router-view /> <!-- Platzhalter für die aktuelle View -->
  </div>
  <!-- <div class="konto">
      <h3 class="konto">Konto: {{ konto }}</h3>
    </div> -->
</template>

<script>
export default {
  name: "App",
  components: {
    NavBar
  },
};

import NavBar from './components/NavBar.vue'
</script>
